import { DeepLinkType } from '@gem/models/deeplinksModel';

const DEEP_LINK_TYPE_MAP: Record<string, DeepLinkType> = {
  chat: DeepLinkType.Group,
  'sticker.pack': DeepLinkType.StickerPack,
  message: DeepLinkType.Message,
  user: DeepLinkType.User,
  'space.local': DeepLinkType.SpaceLocal,
  call: DeepLinkType.Call,
  room: DeepLinkType.Room,
  callMe: DeepLinkType.CallMe,
  card: DeepLinkType.Card,
  unknown: DeepLinkType.Unknown,
};

export function mapDeepLinkType(type?: string | null): DeepLinkType {
  if (!type) {
    return DeepLinkType.Unknown;
  }

  return DEEP_LINK_TYPE_MAP[type] || DeepLinkType.Unknown;
}
